import React from 'react';
import { getGuidanceSettingsFromStorage } from '../../Pages/Home/SettingsModal/storage-utils';

interface PdfViewerProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  dependOnPdfSettings?: boolean;
}

function PdfViewer({ dependOnPdfSettings, ...props }: PdfViewerProps) {
  const { showPdfViewer } = getGuidanceSettingsFromStorage();

  /** Need to check exactly for 'false', because if settings never was saved, then this val will be 'undefined' */
  if (dependOnPdfSettings && showPdfViewer === false) {
    return <p className="text-destructive">You disabled the pdf-viewer in settings</p>;
  }

  return <iframe title="pdf-viewer" width="100%" height="625px" {...props} />;
}

PdfViewer.defaultProps = {
  dependOnPdfSettings: false,
};

export default PdfViewer;
